const headList = [
  {
    headTitle: "",
    width: "25%",
  },
  {
    headTitle: "件数",
    width: "25%",
  },
  {
    headTitle: "金額",
    width: "25%",
  },
  {
    headTitle: "平均処理日数",
    width: "25%",
  },
];

const defaultBodyList = [
  {
    aggregationMonth: "累計",
    billerCount: 0,
    billerAmount: 0,
    averageProcessingDays: 0,
  },
];

const infoHeadList = [
  {
    headTitle: "区分",
  },
  {
    headTitle: "データ作成日",
  },
  {
    headTitle: "振込予定日",
  },
  {
    headTitle: "処理状況",
  },
  {
    headTitle: "合計件数",
    dontNeedSort: true,
  },
  {
    headTitle: "合計金額",
    dontNeedSort: true,
  },
  {
    headTitle: "振込データ",
  },
  {
    headTitle: "状況",
  },
];

const monthMapping = [
  { label: "累計", value: "all" },
  { label: "4月", value: "4" },
  { label: "5月", value: "5" },
  { label: "6月", value: "6" },
  { label: "7月", value: "7" },
  { label: "8月", value: "8" },
  { label: "9月", value: "9" },
  { label: "10月", value: "10" },
  { label: "11月", value: "11" },
  { label: "12月", value: "12" },
  { label: "1月", value: "1" },
  { label: "2月", value: "2" },
  { label: "3月", value: "3" },
];

export { infoHeadList, headList, monthMapping, defaultBodyList };
